import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tags",
  "use": "icon-tags-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-tags\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <path d=\"M875.797333 172.864 875.797333 172.864 693.781333 0 217.578667 0C167.509333 0 117.333333 38.101333 117.333333 88.192l0 823.893333C117.333333 962.197333 167.509333 1024 217.578667 1024L814.72 1024c50.090667 0 91.946667-61.802667 91.946667-111.914667L906.666667 200.618667 875.797333 172.864zM864 903.936C864 952.192 837.845333 981.333333 791.765333 981.333333L240.576 981.333333C194.453333 981.333333 160 952.192 160 903.936L160 112.341333C160 64.042667 194.453333 42.666667 240.576 42.666667L672 42.666667l0 146.282667 192 12.352L864 903.936z\" p-id=\"19284\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tags.svg
// module id = vNLF
// module chunks = 60